import { gql, MutationHookOptions, useMutation } from '@apollo/client';

const MUTATION = gql`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      email
      role {
        id
        name
      }
      isActive
    }
  }
`;

export type Variables = {
    input: {
        id: string;
        email?: string;       // jeśli możesz aktualizować
        roleId?: string;
        isActive?: boolean;
    };
};

export type Response = {
    updateUser: {
        id: string;
        email: string;
        role: {
            id: string;
            name: string;
        };
        isActive: boolean;
    };
};

export const useUpdateUserMutation = (
    options?: MutationHookOptions<Response, Variables>
) => useMutation<Response, Variables>(MUTATION, options);
